import React from "react";
import PropTypes from "prop-types";

const AlertFieldEditor = ({ config, rule, onChange, onDelete }) => {
  const handleInputChange = (e) => {
    onChange({ ...config, [e.target.name]: e.target.value });
  };

  const handleTypeChange = (e) => {
    const newType = e.target.value;
    const base = {
      type: newType,
      triggerMessage: "",
    };
    if (newType === "one-bound") {
      base.threshold = 0;
      base.boundary = "min";
    } else if (newType === "two-bound") {
      base.low = 0;
      base.high = 0;
    } else if (newType === "fault-code") {
      base.faultCode = "";
    }
    onChange(base);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6 relative">
      {onDelete && (
        <button
          onClick={onDelete}
          className="absolute top-4 right-4 text-red-600 text-sm hover:underline"
        >
          Delete
        </button>
      )}

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Trigger Message
          </label>
          <input
            type="text"
            name="triggerMessage"
            value={config.triggerMessage || ""}
            onChange={handleInputChange}
            className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Alert Type
          </label>
          <select
            name="type"
            value={config.type}
            onChange={handleTypeChange}
            className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
          >
            {rule.allowedTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {config.type === "one-bound" && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Threshold
              </label>
              <input
                type="number"
                name="threshold"
                value={config.threshold}
                onChange={handleInputChange}
                className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Boundary
              </label>
              <select
                name="boundary"
                value={config.boundary}
                onChange={handleInputChange}
                className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
              >
                <option value="min">min</option>
                <option value="max">max</option>
              </select>
            </div>
          </div>
        )}

        {config.type === "two-bound" && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Low
              </label>
              <input
                type="number"
                name="low"
                value={config.low}
                onChange={handleInputChange}
                className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                High
              </label>
              <input
                type="number"
                name="high"
                value={config.high}
                onChange={handleInputChange}
                className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
              />
            </div>
          </div>
        )}

        {config.type === "fault-code" && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fault Code
            </label>
            <input
              type="text"
              name="faultCode"
              value={config.faultCode || ""}
              onChange={handleInputChange}
              className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-blue-500 focus:outline-none"
            />
          </div>
        )}
      </div>
    </div>
  );
};

AlertFieldEditor.propTypes = {
  field: PropTypes.string.isRequired,
  rule: PropTypes.shape({
    label: PropTypes.string.isRequired,
    allowedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  config: PropTypes.shape({
    faultCode: PropTypes.string,
    triggerMessage: PropTypes.string,
    type: PropTypes.string,
    threshold: PropTypes.number,
    boundary: PropTypes.string,
    low: PropTypes.number,
    high: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};

export default AlertFieldEditor;
